import axios from "axios";

function resolveBackendUrl() {
  if (typeof window !== "undefined" && window.__GX_API_ORIGIN__) {
    return String(window.__GX_API_ORIGIN__).replace(/\/$/, "");
  }
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
}

const BACKEND_URL = resolveBackendUrl();

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = String(err.config?.url || "");
    const skipAuth = /\/auth\/(login|register|me|refresh|forgot-password|reset-password|verify-email|resend-verification)/.test(url);
    if (status === 401 && !skipAuth && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("gx-session-expired"));
    }
    const skipBilling = /\/billing\//.test(url);
    if (status === 402 && !skipBilling && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("gx-subscription-expired", {
        detail: typeof err.response?.data?.detail === "string" ? err.response.data.detail : "",
      }));
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
